"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @phrospr/backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.6.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseILeadTypeEntity = void 0;
const ilead_type_data_1 = require("./ilead-type-data");
function parseILeadTypeEntity(data) {
    if (data.data !== null && typeof data.data === 'object')
        data.data = (0, ilead_type_data_1.parseILeadTypeData)(data.data);
    return data;
}
exports.parseILeadTypeEntity = parseILeadTypeEntity;
